import { z } from 'zod';
/**
 * Available artifact kinds
 */ export const artifactKinds = [
    'text',
    'code',
    'image',
    'sheet',
    'document',
    'powerpoint',
    'presentation'
];
/**
 * Schema for parsing raw artifact data
 */ const rawArtifactDataSchema = z.object({
    id: z.string(),
    title: z.string(),
    kind: z.enum(artifactKinds),
    content: z.string().optional().default(''),
    progressCallId: z.string().optional(),
    sourceAttachmentId: z.string().optional(),
    sourceUrl: z.string().optional(),
    contentType: z.string().optional()
});
/**
 * Zod schema that validates and transforms raw artifact data into ArtifactPreviewInlineProps
 */ export const artifactDataSchema = rawArtifactDataSchema.transform((data)=>({
        id: data.id,
        title: data.title,
        kind: data.kind,
        content: data.content,
        progressCallId: data.progressCallId,
        sourceAttachmentId: data.sourceAttachmentId,
        sourceUrl: data.sourceUrl,
        contentType: data.contentType
    }));
